import { render, staticRenderFns } from "./UserSettingsClubInfo.vue?vue&type=template&id=3d7a65fe&"
import script from "./UserSettingsClubInfo.vue?vue&type=script&lang=js&"
export * from "./UserSettingsClubInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports